/**
 * 预览弹框组件
 * @author chenqunfeng
 * @since 17/11/15
 */

import './scene-dialog.less';

import React from 'react';
import cx from 'classnames';

import PreviewIframe from 'components/preview/iframe';
import PreviewIframeOperationBar from 'components/preview/iframe-operation-bar';
import PreviewForwardView from 'components/preview/forward-view';
import PreviewAuthInfo from 'components/preview/auth-info';
import PreviewOperationBar from 'components/preview/operation-bar';
import PreviewVipRecommend from 'components/preview/vip-recommend';
import PreviewPrice from 'components/preview/price';
import PreviewBuybtn from 'components/preview/buy-btn';
import PreviewPublishTime from 'components/preview/publish-time';
import PreviewUseTime from 'components/preview/use-time';
import PreviewPluginTag from 'components/preview/plugin-tag';
import VARIABLES from 'constants/variable.json5';
import PosterPreview from 'components/poster-preview/poster-preview';
import { showRabbitBrandInfo } from 'utils/user';
import * as statisticSDK from 'utils/statisticSDK';

// 自定义标签容器宽度
const CUSTOME_TAG_BOX_WIDTH = 379;
// 自定义标签字号
const TAG_FONT_SIZE = 14;
// 自定义标签padding+margin
const TAG_ITEM_MARGIN = 34;
// 自定义标签最大行数
const MAX_LINE_OPEN_ZONE = 4;
const MAX_LINE_ORG_ZONE = 2;
// 海报类型
const POSTER_TYPE = 15;

// 获取作品预览左边模版,包含预览iframe,翻页按钮,二维码
export function getPreviewLeft(opts) {
  const { tplData } = opts;
  const { type } = opts.tplData;

  return (
    <div className="s-preview-left">
      {type === VARIABLES.POSTER ? (
        <PosterPreview data={tplData} />
      ) : (
        <PreviewIframe data={tplData} />
      )}
      <PreviewIframeOperationBar data={tplData} />
    </div>
  );
}

// 计算是否隐藏溢出标签
const checkTagsOverflow = (tags, isOrgZone) => {
  let row = 1;
  let sumWidth = 0;
  const maxLine = isOrgZone ? MAX_LINE_ORG_ZONE : MAX_LINE_OPEN_ZONE;
  tags.forEach((tag, index) => {
    const tagWidth = tag.name.length * TAG_FONT_SIZE + TAG_ITEM_MARGIN;
    if (sumWidth + tagWidth > CUSTOME_TAG_BOX_WIDTH) {
      if (row === maxLine) {
        // 将第四行最后一个元素name改为...,并且隐藏剩余元素
        tags[index - 1].name = '...';
        tags.splice(index);
      } else {
        row += 1;
        sumWidth = tagWidth;
      }
    } else {
      sumWidth += tagWidth;
    }
  });
  return tags;
};

// 渲染自定义标签
const renderCustomTags = (tags, isPoster) => {
  if (!Array.isArray(tags) || tags.length < 1) return null;
  return (
    <div className={cx('custom-tag-container', { isPoster })}>
      <span className="title">自定义分组:</span>
      <ul className="tags">
        {tags.map(tag => (
          <li className="tag-item" key={tag.tagId}>
            {tag.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

// 获取作品预览右边HTML模版
export function getPreviewRight(opts) {
  const {
    state,
    tplData,
    userInfo,
    getBuyState,
    buyTemplate,
    buyLocalTemplate,
    setTplCollectionStatus,
    activeIndex,
  } = opts;
  const { coupon, buyState } = state;
  const { category, tags, platformTemplate, tplSpecies, orgTags } = tplData;
  const isOpenZone = category === VARIABLES.OPENZONE || !!platformTemplate;
  const isOrgZone = category === VARIABLES.ENTERPRISE;
  const isPoster = +tplSpecies === POSTER_TYPE;
  const showTags = isOrgZone ? orgTags : tags;
  const newTags = checkTagsOverflow(showTags || [], isOrgZone);

  const showBrandInfo = showRabbitBrandInfo();

  return (
    <div className={cx('s-preview-right', tplData.type.toLowerCase())}>
      <div className="s-preview-content">
        <PreviewForwardView data={tplData} />
        <PreviewPublishTime data={tplData} />
        <PreviewOperationBar
          data={tplData}
          userInfo={userInfo}
          setTplCollectionStatus={setTplCollectionStatus}
        />
      </div>
      {/* 企业专区自定义标签 */}
      {isOrgZone && renderCustomTags(newTags, isPoster)}
      {/* 平台专区隐藏模板作者、技巧中心、玩法类型，仅展示自定义标签 */}
      {isOpenZone ? (
        renderCustomTags(newTags, isPoster)
      ) : (
        <>
          <PreviewAuthInfo data={tplData} />
          {showBrandInfo && (
            <div
              className={`s-preview-sparkle ${
                +activeIndex === 7 ? 's-preview-sparkle-enterprise' : ''
              }`}>
              <a
                href="/sparkle/"
                target="_blank"
                onClick={() => {
                  statisticSDK.pushCustomEvent('c_click', {
                    c_elmname: '技巧中心',
                    c_elmcontent: `${tplData.title}-${
                      tplData.tplPrice ? '付费' : '免费'
                    }`,
                    c_elmtype: 'button',
                    c_component: 'TemplateLayer',
                  });
                }}>
                还想解锁更多玩法亮点？快来技巧中心了解一下&gt;&gt;
              </a>
            </div>
          )}
          <PreviewPluginTag
            className={showBrandInfo ? '' : 's-plugin-tag-margin'}
            data={tplData}
          />
        </>
      )}

      <div className="s-preview-footer">
        <PreviewPrice data={tplData} coupon={coupon} />
        <PreviewUseTime data={tplData} />
        <PreviewBuybtn
          data={tplData}
          coupon={coupon}
          userInfo={userInfo}
          buyState={buyState}
          getBuyState={getBuyState}
          buyTemplate={buyTemplate}
          buyLocalTemplate={buyLocalTemplate}
        />
        <PreviewVipRecommend data={tplData} userInfo={userInfo} />
      </div>
    </div>
  );
}
